import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";
import { readApiErrorMessage } from "../utils/clientRestrictionsUi";

export async function listClientRequests({ status, scope, network_id } = {}) {
    const url = new URL(`${API_BASE}/requests/client`);
    if (status) url.searchParams.set("status", status);
    if (scope) url.searchParams.set("scope", scope);
    if (network_id) url.searchParams.set("network_id", String(network_id));

    const res = await apiFetch(url.toString());
    if (!res.ok) {
        throw new Error(await readApiErrorMessage(res, "Не вдалося завантажити заявки"));
    }
    return await res.json();
}

export async function createClientRequest({ description, network_id = null, location_id = null }) {
    const res = await apiFetch(`${API_BASE}/requests/client`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ description, network_id, location_id }),
    });
    if (!res.ok) {
        throw new Error(await readApiErrorMessage(res, "Не вдалося створити заявку"));
    }
    return await res.json();
}

export async function closeClientRequest(requestId, comment = null) {
    const res = await apiFetch(`${API_BASE}/requests/client/${requestId}/close`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ comment }),
    });
    if (!res.ok) {
        throw new Error(await readApiErrorMessage(res, "Не вдалося закрити заявку"));
    }
    return await res.json();
}

export async function addClientRequestMessage(requestId, body) {
    const res = await apiFetch(`${API_BASE}/requests/client/${requestId}/messages`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ body }),
    });
    if (!res.ok) {
        throw new Error(await readApiErrorMessage(res, "Не вдалося додати коментар"));
    }
    return await res.json();
}

export async function uploadClientRequestAttachment(requestId, file) {
    const form = new FormData();
    form.append("file", file);
    const res = await apiFetch(`${API_BASE}/requests/client/${requestId}/attachments`, {
        method: "POST",
        body: form,
    });
    if (!res.ok) {
        throw new Error(await readApiErrorMessage(res, "Не вдалося завантажити фото"));
    }
    return await res.json();
}

export function clientRequestAttachmentUrl(fileUrl) {
    if (!fileUrl) return "";
    return `${API_BASE}/requests/client/download/${encodeURIComponent(fileUrl)}`;
}

export async function fetchClientRequestAttachmentBlob(fileUrl) {
    const res = await apiFetch(clientRequestAttachmentUrl(fileUrl));
    if (!res.ok) throw new Error("Не вдалося завантажити файл");
    return await res.blob();
}
